import React from 'react'
import Modal from 'react-responsive-modal'
import { pluralize } from './buildGrid'
import styles from './styles.module.css'

// Окно занятия — только просмотр: полный состав занятия, ни одной кнопки,
// изменяющей данные (п. 7.8 ТЗ). Закрытие по кнопке, подложке и Esc, блокировка
// прокрутки с компенсацией полосы — на стороне react-responsive-modal.
const Value = ({ value }) => (value
  ? <span className={styles.modalValue}>{value}</span>
  : <span className={`${styles.modalValue} ${styles.modalNone}`}>не заполнено</span>)

const List = ({ items, kind }) => {
  if (!items.length) return <Value value="" />
  if (items.length === 1) return <Value value={items[0]} />

  return (
    <div className={styles.modalValue} style={{ minWidth: 0 }}>
      <div className={styles.modalCount}>{items.length} {pluralize(items.length, kind)}</div>
      <ul className={styles.modalList}>
        {items.map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}
      </ul>
    </div>
  )
}

const Row = ({ label, children }) => (
  <div className={styles.modalRow}>
    <span className={styles.modalKey}>{label}</span>
    {children}
  </div>
)

const LessonModal = ({ lesson, onClose }) => (
  <Modal
    open={Boolean(lesson)}
    onClose={onClose}
    center
    showCloseIcon={false}
    reserveScrollBarGap
    classNames={{ modal: styles.modal }}
  >
    {lesson && (
      <>
        <div className={styles.modalHead}>
          <div className={styles.modalTitle}>{lesson.alias}</div>
          <div className={styles.modalSub}>{lesson.subtitle}</div>
        </div>

        <div className={styles.modalBody}>
          <Row label="Дисциплина"><Value value={lesson.discipline} /></Row>
          <Row label="Вид занятия"><Value value={lesson.typeName} /></Row>
          <Row label="Номер темы"><Value value={lesson.themeNumber} /></Row>
          <Row label="Тема занятия"><Value value={lesson.themeTitle} /></Row>
          <Row label="Аудитории"><List items={lesson.rooms} kind="rooms" /></Row>
          <Row label="Преподаватели"><List items={lesson.teachers} kind="teachers" /></Row>
        </div>

        <div className={styles.modalFoot}>
          <button type="button" className={styles.modalClose} onClick={onClose}>
            Закрыть
          </button>
        </div>
      </>
    )}
  </Modal>
)

export default LessonModal
